var e={exports:{}};export{e as __module};
//# sourceMappingURL=rabbit-legacy.js.map
